export default __webpack_public_path__ + "static/media/generative.df832ece.gif";